/**
 * UI Watchdog — detects frozen UI and auto-reloads.
 *
 * Posts a heartbeat every 5s. If the check timer detects 3 missed
 * beats (15s), the UI is considered frozen and force-reloads.
 *
 * In CW Browser: also notifies Electron main process.
 * In Web mode: uses a secondary timer as fallback.
 */

import { trackFreeze } from "./healthReporter";

const HEARTBEAT_INTERVAL = 5000;  // 5s between beats
const FREEZE_THRESHOLD = 15000;   // 15s = frozen
let lastBeat = Date.now();
let heartbeatTimer = null;
let checkTimer = null;
let started = false;

function beat() {
  lastBeat = Date.now();
}

function check() {
  const elapsed = Date.now() - lastBeat;
  if (elapsed > FREEZE_THRESHOLD) {
    console.error(`[Watchdog] UI frozen for ${Math.round(elapsed / 1000)}s — reloading`);
    trackFreeze();

    // Log to observability before reload
    try {
      if (window.electronAPI?.observability?.log) {
        window.electronAPI.observability.log("error", "freeze", `UI frozen for ${Math.round(elapsed / 1000)}s`, {
          lastBeat: new Date(lastBeat).toISOString(),
          elapsed,
          url: window.location.href,
        });
      }
    } catch {}

    // Force reload
    window.location.reload();
  }
}

export function startWatchdog() {
  if (started) return;
  started = true;
  lastBeat = Date.now();

  // Heartbeat: proves the main thread is responsive
  heartbeatTimer = setInterval(beat, HEARTBEAT_INTERVAL);

  // Check: runs slightly offset, detects missed beats
  checkTimer = setInterval(check, HEARTBEAT_INTERVAL + 1000);

  console.debug("[Watchdog] Started — freeze threshold:", FREEZE_THRESHOLD / 1000, "s");
}

